import { ComponentPropsWithoutRef, ForwardedRef, forwardRef } from 'react';
import { twJoin } from 'tailwind-merge';

type Variant = 'selected-primary' | 'selected' | 'unselected';
interface FilterTagProps extends ComponentPropsWithoutRef<'div'> {
    variant?: Variant;
}

const FilterTag = forwardRef((props: FilterTagProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { className, variant = 'unselected', ...rest } = props;
    return (
        <div
            ref={ref}
            className={twJoin(
                variant === 'unselected' && 'border-dashed border-gray-300 px-2',
                variant === 'selected' && 'border-gray-200 bg-white px-2.5',
                className,
                'flex items-center gap-1 rounded-full border text-sm leading-none hover:bg-gray-100',
            )}
            {...rest}
        />
    );
});

export { FilterTag };
